import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, Lock } from "lucide-react";
import { api } from "../lib/api";
import { BRAND } from "../lib/content";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("ta_admin_token", data.access_token);
      navigate("/admin");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      setError(typeof detail === "string" ? detail : "Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-ink px-6">
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[400px] w-[400px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-flame opacity-15 blur-[130px]" />
      <img src={BRAND.web} alt="" className="pointer-events-none absolute left-0 top-0 w-24 opacity-30" />
      <img src={BRAND.web} alt="" className="pointer-events-none absolute bottom-0 right-0 w-24 -scale-100 opacity-30" />

      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="relative z-10 w-full max-w-md border border-white/10 bg-surface/60 p-10 backdrop-blur-xl"
      >
        <div className="mb-8 text-center">
          <span className="mx-auto flex h-14 w-14 items-center justify-center border border-flame/50 text-flame">
            <Lock size={22} />
          </span>
          <h1 className="mt-6 font-display text-3xl font-light tracking-tight text-white">Admin Access</h1>
          <p className="mt-2 font-gothic text-xs uppercase tracking-[0.25em] text-flame">Subscriber Dashboard</p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <input
            data-testid="admin-email-input"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email"
            className="h-13 w-full rounded-none border border-white/20 bg-black px-5 py-3.5 font-body text-white placeholder:text-white/30 outline-none focus:border-flame"
          />
          <input
            data-testid="admin-password-input"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password"
            className="h-13 w-full rounded-none border border-white/20 bg-black px-5 py-3.5 font-body text-white placeholder:text-white/30 outline-none focus:border-flame"
          />
          {error && (
            <p data-testid="admin-login-error" className="font-body text-sm text-crimson">{error}</p>
          )}
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={loading}
            className="flex h-13 w-full items-center justify-center gap-2 border border-flame bg-flame py-3.5 font-body text-xs uppercase tracking-[0.2em] text-ink transition-colors hover:bg-ember disabled:opacity-70"
          >
            {loading ? <Loader2 className="animate-spin" size={18} /> : null}
            Enter Dashboard
          </button>
        </form>
      </motion.div>
    </div>
  );
}
